__turbopack_context__.v({
  "album": "Photos-module__lqm6da__album",
  "albumCount": "Photos-module__lqm6da__albumCount",
  "albumHeader": "Photos-module__lqm6da__albumHeader",
  "albumText": "Photos-module__lqm6da__albumText",
  "albumTitle": "Photos-module__lqm6da__albumTitle",
  "arrow": "Photos-module__lqm6da__arrow",
  "arrowNext": "Photos-module__lqm6da__arrowNext",
  "arrowPrev": "Photos-module__lqm6da__arrowPrev",
  "badge": "Photos-module__lqm6da__badge",
  "chip": "Photos-module__lqm6da__chip",
  "chipActive": "Photos-module__lqm6da__chipActive",
  "close": "Photos-module__lqm6da__close",
  "counter": "Photos-module__lqm6da__counter",
  "fadeIn": "Photos-module__lqm6da__fadeIn",
  "filters": "Photos-module__lqm6da__filters",
  "fullscreenBtn": "Photos-module__lqm6da__fullscreenBtn",
  "inner": "Photos-module__lqm6da__inner",
  "intro": "Photos-module__lqm6da__intro",
  "lightbox": "Photos-module__lqm6da__lightbox",
  "lightboxCaption": "Photos-module__lqm6da__lightboxCaption",
  "lightboxCounter": "Photos-module__lqm6da__lightboxCounter",
  "lightboxFrame": "Photos-module__lqm6da__lightboxFrame",
  "lightboxImage": "Photos-module__lqm6da__lightboxImage",
  "page": "Photos-module__lqm6da__page",
  "preload": "Photos-module__lqm6da__preload",
  "stage": "Photos-module__lqm6da__stage",
  "stageCaption": "Photos-module__lqm6da__stageCaption",
  "stageImage": "Photos-module__lqm6da__stageImage",
  "stageShade": "Photos-module__lqm6da__stageShade",
  "stageText": "Photos-module__lqm6da__stageText",
  "stageTitle": "Photos-module__lqm6da__stageTitle",
  "thumb": "Photos-module__lqm6da__thumb",
  "thumbActive": "Photos-module__lqm6da__thumbActive",
  "thumbImage": "Photos-module__lqm6da__thumbImage",
  "thumbLabel": "Photos-module__lqm6da__thumbLabel",
  "thumbSignature": "Photos-module__lqm6da__thumbSignature",
  "thumbs": "Photos-module__lqm6da__thumbs",
});
